<template>
  <div v-if="isStale" class="penalty-recalc-stale-text red--text">
    {{ message }}
  </div>
</template>

<script>
import { PENALTY_OUTDATED_MESSAGE } from './resalePenaltyStale.mixin';
import '../../../../assets/style.css';

/**
 * The "Penalty outdated" line that sits directly beneath the June Resale Recalculate button.
 * Shared by the Resale Property List and Day of Sale so the two screens cannot drift into two
 * different wordings of the same warning. Staleness itself is decided by
 * resalePenaltyStale.mixin - this component only renders the result.
 */
export default {
  name: 'ResalePenaltyStaleWarning',
  props: {
    isStale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    message() {
      return PENALTY_OUTDATED_MESSAGE;
    },
  },
};
</script>
